import { extractTextFromQuery } from '../../../utils/query';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word) {
          return {
            firstName: {
              $ilike: `%${word}%`
            }
          };
        }).concat(words.map(function(word) {
          return {
            lastName: {
              $ilike: `%${word}%`
            }
          };
        }))
      }
    }
  }
}
